import React from 'react'
import { Alert } from 'react-bootstrap'
import AutoAffix from 'react-overlays/lib/AutoAffix'
import PropTypes from 'prop-types'

class Error extends React.Component {
	constructor(props) {
		super(props)
		this.state = {visible: true}
		this.handleAlertDismiss = this.handleAlertDismiss.bind(this)
		this.handleAlertShow = this.handleAlertShow.bind(this)
	}

	componentDidUpdate(prevProps, prevState) {
		// Show a later submission error when the parent keeps this component mounted.
		if (!prevState.visible) {
			this.handleAlertShow()
		}
	}

	handleAlertDismiss() {
		const { onDismiss } = this.props
		this.setState({visible: false})
		onDismiss && onDismiss()
	}

	handleAlertShow() {
		this.setState({visible: true})
	}

	render() {
		const { visible } = this.state
		if (visible) {
			const { message, showDismiss = true, absolute = false } = this.props
			return <div className={absolute ? 'bv-affix-wrapper-pabs-w100-z1' : 'bv-affix-wrapper'}>
				<AutoAffix container={window.bvmain} affixClassName="sticky-header">
					<Alert bsStyle="danger" bsClass="bv-custom-notification bv-notification-error" onDismiss={showDismiss ? this.handleAlertDismiss : null}>
						<p style={{paddingTop: "7px"}}>{message || "Something went wrong! Please refresh this page or contact us."}</p>
					</Alert>
				</AutoAffix>
			</div>
		}
		return null
	}
}

Error.propTypes = {
	message: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.node
	]),
	onDismiss: PropTypes.func,
	showDismiss: PropTypes.bool
}

export default Error
